import {
  Alert,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

interface ConfirmAutoApproveOffDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmAutoApproveOffDialog = ({
  onConfirm,
  onCancel,
}: ConfirmAutoApproveOffDialogProps) => {
  return (
    <>
      <DialogTitle>Turn Off Auto-approval?</DialogTitle>
      <Divider light />
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2">
            Are you sure you want to disable auto-approval for new users from
            your organization?
          </Typography>
          <Alert severity="warning">
            When disabled, new users will only be able to sign-up via an
            invitation.
          </Alert>
        </Stack>
      </DialogContent>
      <Divider light />
      <DialogActions sx={{ my: 1, mx: 2 }}>
        <Button
          autoFocus
          variant="contained"
          color="primary"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button autoFocus variant="outlined" color="error" onClick={onConfirm}>
          Turn Off Auto-approval
        </Button>
      </DialogActions>
    </>
  );
};
